document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.bnpl-card')) {
        initWidget();
    }
});

function preventModalScroll(event) {
    const bnplModal = document.querySelector('.bnpl-modal');
    if (event.target === bnplModal) event.preventDefault();
}

const closeBnplModal = () => {
    const body = document.querySelector('body');
    body.style.overflow = '';

    const bnplModal = document.querySelector('.bnpl-modal');
    const modalPayments = bnplModal.querySelector('.bnpl-schedule-calc__payments');
    bnplModal.classList.remove('bnpl-modal--open');
    bnplModal.removeEventListener('wheel', preventModalScroll, {passive: false});
    bnplModal.removeEventListener('touchmove', preventModalScroll, {passive: false});

    modalPayments.querySelectorAll('.bnpl-schedule-calc__part').forEach((el) => el.remove());
    const others = modalPayments.querySelector('.bnpl-schedule-calc__others');
    if (others) others.remove();
};

function getDictIndex(amount) {
    const last = String(amount).slice(-1);
    const penult = String(amount).slice(-2, -1);
    if (penult === '1') return 2;
    if (last === '1') return 0;
    if (['2', '3', '4'].includes(last)) return 1;
    return 2;
}

function getLinesTemplate(numRecs) {
    const isMany = numRecs > 3 && numRecs <= 5;
    return `<div class="bnpl-schedule-calc__lines ${isMany ? 'bnpl-schedule-calc__lines--many' : ''}">
        ${numRecs <= 5 ? Array(numRecs).fill('<div></div>').join('') : '<div></div>'}
    </div>`;
}

function getDatesArr(numRecs, interval, isFormatted = false) {
    return Array.from({length: numRecs}, (_, i) => {
        const now = new Date();
        const date = now.setDate(now.getDate() + interval * (i + 1));
        return isFormatted ? getDateWithMonth(date) : date;
    });
}

function toNumber(string) {
    return Number(string.replace(/,/, '.'));
}

function getElementFromTemplate(template) {
    const el = document.createElement('div');
    el.innerHTML = template;
    return el.children[0];
}

function checkWeeks(daysAmount) {
    return daysAmount >= 7 && !(daysAmount % 7);
}

function getDaysFromNow(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const days = Math.floor((new Date(date) - today) / 86400000);
    return `${days} ${getDaysFormatted(days)}`;
}

function getDateWithMonth(date) {
    const d = new Date(date);
    const months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря',
    ];
    return `${d.getDate()} ${months[d.getMonth()]}`;
}

function getPaymentsFormatted(amount) {
    return ['платеж', 'платежа', 'платежей'][getDictIndex(amount)];
}

function getEveryFormatted(amount) {
    return ['каждую', 'каждые', 'каждые'][getDictIndex(amount)];
}

function getDaysFormatted(amount, isGen = false) {
    return isGen ? ['дня', 'дней', 'дней'][getDictIndex(amount)] : ['день', 'дня', 'дней'][getDictIndex(amount)];
}

function getWeeksFormatted(amount, isGen = false) {
    return isGen
        ? ['недели', 'недель', 'недель'][getDictIndex(amount)]
        : ['неделю', 'недели', 'недель'][getDictIndex(amount)];
}

function openBnplModal(params) {
    const body = document.querySelector('body');
    body.style.overflow = 'hidden';

    const bnplModal = document.querySelector('.bnpl-modal');
    const modalCloseButton = bnplModal.querySelector('.bnpl-modal__close');

    if (bnplModal.parentElement !== body) {
        document.body.appendChild(bnplModal);
    }

    modalCloseButton && modalCloseButton.addEventListener('click', closeBnplModal);
    bnplModal &&
        bnplModal.addEventListener('click', (e) => {
            if (e.target === bnplModal) closeBnplModal();
        });

    const bnplSpoilerHeader = bnplModal.querySelector('.bnpl-modal-spoiler__header');
    bnplSpoilerHeader &&
        bnplSpoilerHeader.addEventListener('click', (e) => {
            const spoiler = e.target.closest('.bnpl-modal-spoiler');
            const spoilerBody = spoiler.querySelector('.bnpl-modal-spoiler__body');
            spoiler.classList.toggle('bnpl-modal-spoiler--open');
            spoilerBody.style.maxHeight = spoiler.classList.contains('bnpl-modal-spoiler--open')
                ? spoilerBody.scrollHeight + 'px'
                : null;
        });

    const modalFirstPercent = bnplModal.querySelectorAll('.bnpl-first-percent');
    const modalFirstAmount = bnplModal.querySelectorAll('.bnpl-first-amount');
    const modalRecsPercent = bnplModal.querySelectorAll('.bnpl-recs-percent');
    const modalRecPercent = bnplModal.querySelectorAll('.bnpl-rec-percent');
    const modalRecInterval = bnplModal.querySelectorAll('.bnpl-rec-interval');
    const modalRecIntervalEvery = bnplModal.querySelectorAll('.bnpl-rec-interval-every');
    const modalPayments = bnplModal.querySelector('.bnpl-schedule-calc__payments');

    bnplModal.classList.add('bnpl-modal--open');
    bnplModal.addEventListener('wheel', preventModalScroll, {passive: false});
    bnplModal.addEventListener('touchmove', preventModalScroll, {passive: false});

    modalFirstAmount.forEach((el) => (el.innerHTML = params.firstPayment.toLocaleString('ru-RU')));
    modalFirstPercent.forEach((el) => (el.innerHTML = params.firstPaymentPercents.toLocaleString('ru-RU')));
    modalRecsPercent.forEach((el) => (el.innerHTML = params.recsPercents.toLocaleString('ru-RU')));
    modalRecPercent.forEach((el) => (el.innerHTML = Number(params.recPercents).toLocaleString('ru-RU')));

    const intervalStr = params.isWeeks
        ? Math.floor(params.paymentsInterval / 7) > 1
            ? `раз в ${Math.floor(params.paymentsInterval / 7)} ${getWeeksFormatted(Math.floor(params.paymentsInterval / 7))}`
            : 'раз в неделю'
        : `раз в ${params.paymentsInterval} ${getDaysFormatted(params.paymentsInterval)}`;

    modalRecInterval.forEach((el) => (el.innerHTML = intervalStr));

    const intervalEveryStr = params.isWeeks
        ? Math.floor(params.paymentsInterval / 7) > 1
            ? `каждые ${Math.floor(params.paymentsInterval / 7)} ${getWeeksFormatted(Math.floor(params.paymentsInterval / 7))}`
            : 'каждую неделю'
        : `каждые ${params.paymentsInterval} ${getDaysFormatted(params.paymentsInterval)}`;

    modalRecIntervalEvery.forEach((el) => (el.innerHTML = intervalEveryStr));

    // Подстановка расписания
    if (params.numRecPayments >= 4) {
        const tpl = `<div class="bnpl-schedule-calc__part bnpl-schedule-calc__part--combined">
            ${getLinesTemplate(params.numRecPayments)}
            <div class="bnpl-schedule-calc__descr">Еще ${params.numRecPayments} ${getPaymentsFormatted(params.numRecPayments)} ${intervalStr}</div>
            <div class="bnpl-schedule-calc__sum">по ${Number(params.recAmount).toLocaleString('ru-RU')} ₽</div>
        </div>`;
        modalPayments.append(getElementFromTemplate(tpl));
    } else {
        const tpl = (date) => `<div class="bnpl-schedule-calc__part">
            <div class="bnpl-schedule-calc__descr">через ${getDaysFromNow(date)}</div>
            <div class="bnpl-schedule-calc__sum">${Number(params.recAmount).toLocaleString('ru-RU')} ₽</div>
        </div>`;
        const frag = new DocumentFragment();
        getDatesArr(params.numRecPayments, params.paymentsInterval).forEach((d) =>
            frag.append(getElementFromTemplate(tpl(d)))
        );
        modalPayments.append(frag);
    }

    // Для мобильных
    const tplMobile = `<div class="bnpl-schedule-calc__others">
        ${getLinesTemplate(params.numRecPayments)}
        <div class="bnpl-schedule-calc__descr">Еще ${params.numRecPayments} ${getPaymentsFormatted(params.numRecPayments)} раз в ${params.paymentsInterval} ${getWeeksFormatted(params.paymentsInterval)}</div>
        <div class="bnpl-schedule-calc__sum">по ${Number(params.recAmount).toLocaleString('ru-RU')} ₽</div>
    </div>`;
    const todayEl = modalPayments.querySelector('.bnpl-schedule-calc__today');
    todayEl && todayEl.after(getElementFromTemplate(tplMobile));
}

function getPaymentAmount(amount) {
    const [rub, kop] = String(amount).split('.');
    return `${rub.toLocaleString('ru-RU')}<span class="bnpl-kopecks">,${kop} ₽</span>`;
}

function updateCard(card, payments) {
    card.querySelector('.bnpl-schedule-calc__today .bnpl-schedule-calc__sum').innerHTML =
        `${payments.firstPayment.toLocaleString('ru-RU')}  <span>₽</span>`;
    card.querySelectorAll('.bnpl-schedule-calc__part').forEach((el) => el.remove());

    if (payments.numPayments > 4 || card.classList.contains('bnpl-card--type-7-js')) {
        const interval = payments.isWeeks ? Math.floor(payments.paymentsInterval / 7) : payments.paymentsInterval;
        const tpl = `<div class="bnpl-schedule-calc__part">
            ${card.classList.contains('bnpl-card--type-7-js') ? getLinesTemplate(payments.numRecPayments) : ''}
            <div class="bnpl-schedule-calc__descr">Еще ${payments.numRecPayments} ${getPaymentsFormatted(payments.numRecPayments)}
                ${interval > 1 ? getEveryFormatted(interval) : 'раз в'} ${interval > 1 ? interval : ''} ${payments.isWeeks ? getWeeksFormatted(interval) : getDaysFormatted(interval)}
            </div>
            <div class="bnpl-schedule-calc__sum">по ${getPaymentAmount(payments.recAmount.toFixed(2))}</div>
        </div>`;
        card.querySelector('.bnpl-schedule-calc').append(getElementFromTemplate(tpl));
    } else {
        const frag = new DocumentFragment();
        getDatesArr(payments.numRecPayments, payments.paymentsInterval, true).forEach((d) => {
            frag.append(
                getElementFromTemplate(`<div class="bnpl-schedule-calc__part">
                <div class="bnpl-schedule-calc__descr">${d}</div>
                <div class="bnpl-schedule-calc__sum">${payments.recAmount.toLocaleString('ru-RU')}  <span> ₽</span></div>
            </div>`)
            );
        });
        card.querySelector('.bnpl-schedule-calc').append(frag);
    }

    const modalButton = card.querySelector('.bnpl-help-button');
    modalButton && (modalButton.onclick = () => openBnplModal(payments));
}

function calcPayments(price, numPayments, firstPaymentPercents, paymentsInterval) {
    const isWeeks = checkWeeks(paymentsInterval);
    const numRecPayments = numPayments - 1;
    const recAmountUnrounded = (price * (1 - 0.01 * firstPaymentPercents)) / numRecPayments;
    const recAmount = Math.floor(recAmountUnrounded * 100) / 100;
    const remainder = recAmountUnrounded - recAmount;
    const firstPayment = ((price * firstPaymentPercents) / 100 + numRecPayments * remainder).toFixed(2);
    const recsPercents = 100 - firstPaymentPercents;
    const recPercents = Number((recsPercents / numRecPayments).toFixed(2));
    const numDays = paymentsInterval * numRecPayments;
    return {
        firstPayment: Number(firstPayment),
        firstPaymentStr: firstPayment,
        recAmount,
        numRecPayments,
        numPayments,
        firstPaymentPercents,
        recsPercents,
        recPercents,
        paymentsInterval,
        isWeeks,
        numDays,
    };
}

function initWidget() {
    const card = document.querySelector('.bnpl-card');
    if (!card) {
        return;
    }

    const price = toNumber(card.dataset.price);
    const firstPaymentPercents = toNumber(card.dataset.firstPaymentPercents);
    const paymentsInterval = toNumber(card.dataset.paymentsInterval);
    const defaultPayments = calcPayments(
        price,
        toNumber(card.dataset.paymentsNumber),
        firstPaymentPercents,
        paymentsInterval
    );
    updateCard(card, defaultPayments);

    card.querySelectorAll('.bnpl-card__radio-item').forEach((item) => {
        item.onclick = () => {
            card.querySelectorAll('.bnpl-card__radio-item').forEach((i) => (i.dataset.checked = 'false'));
            item.dataset.checked = 'true';

            const numPayments = Number(item.dataset.value);
            const payments = calcPayments(price, numPayments, firstPaymentPercents, paymentsInterval);
            updateCard(card, payments);
        };
    });
}
